import React, { memo } from 'react';

import { Status } from 'types/items';

import { OrdersTable } from './OrdersTable';

type Props = {
  startDate?: Date;
  endDate?: Date;
  venue?: string[];
  accountManagers?: string[];
  isDeleting: boolean;
  onDelete: (ids: string[], onSuccess: () => void) => void;
  invoiced: boolean | undefined;
  feeAdjustmentTypes?: string[];
  search?: string;
};

export const PendingInvoiceOrders = memo<Props>((props) => {
  const {
    endDate,
    startDate,
    venue,
    accountManagers,
    invoiced,
    feeAdjustmentTypes,
    search,
  } = props;

  return (
    <OrdersTable
      statusKey={Status.PENDING_INVOICE}
      status={Status.PENDING_INVOICE}
      endDate={endDate}
      startDate={startDate}
      venue={venue}
      accountManagers={accountManagers}
      invoiced={invoiced}
      feeAdjustmentTypes={feeAdjustmentTypes}
      search={search}
    />
  );
});
